import {StringUtils} from '@colonist/utils'
import {isGuestUsernameLengthValid, isRegisteredUsernameLengthValid} from './utils/RandomName.ts'

export class SharedUsernameValidator {
    static isValidLength(loggedIn: boolean, newUsername: string) {
        if(loggedIn) return isRegisteredUsernameLengthValid(newUsername)
        return isGuestUsernameLengthValid(newUsername)
    }

    static containsOnlyAlphanumeric(newUsername: string) {
        return StringUtils.getNonAlphanumericCharacterCount(newUsername) == 0
    }
}
